import { render, staticRenderFns } from "./ArtWork.vue?vue&type=template&id=4ea75227&scoped=true&"
import script from "./ArtWork.vue?vue&type=script&lang=js&"
export * from "./ArtWork.vue?vue&type=script&lang=js&"
import style0 from "./ArtWork.vue?vue&type=style&index=0&id=4ea75227&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea75227",
  null
  
)

export default component.exports